<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="excelFileName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items" :items-per-page="500" :search="search" class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td class="text-center">
								{{ row.item.date_Persian.date }}
							</td>
							<td>
								{{ row.item.description }}
							</td>
							<td class="text-center">
								{{ row.item.purchase.amount.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								{{ row.item.amount.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								{{ row.item.paidToUser.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								<v-btn class="mx-2" fab dark small color="secondary" @click="edit(row.item)">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<div class="d-flex" style="position: absolute;bottom: 0;left: 0;
    right: 0;
    font-size: 22px;
    background-color: rebeccapurple;
    color: #fff;
		justify-content: space-between;
    flex-wrap: wrap;">
			<div class="text-center px-3 py-3">
				مجموع پورسانت ها: {{sum.toString().toPriceFormat()}}
			</div>
			<div class="text-center px-3 py-3">
				مجموع تسویه ها: {{sumPayments.toString().toPriceFormat()}}
			</div>
		</div>
		<v-dialog v-model="dialogModifyCommissionPayment" scrollable persistent max-width="500px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت پرداختی</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyCommissionPayment = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container v-if="dialogModifyCommissionPayment">
						<v-form ref="form" class="mx-2" lazy-validation>
							<v-row>
								<v-col cols="12">
									<div>
										مبلغ کل پورسانت: {{ selectedAffiliateCommission.amount.toString().toPriceFormat() }}
									</div>
									<v-text-money ref="amount" v-model="selectedAffiliateCommission.paidToUser" :label="'*مبلغ تسویه پرداختی'" :error-messages="errorMessages" :rules="[() => selectedAffiliateCommission.paidToUser > 0 || 'مبلغ پرداختی را به صورت صحیح وارد کنید',() => selectedAffiliateCommission.paidToUser <= selectedAffiliateCommission.amount || 'مبلغ پرداختی نباید از مبلغ کل پورسانت بیشتر باشد']" required />
								</v-col>
							</v-row>
							<v-card-actions>
								<v-spacer />
								<v-btn color="blue" dark :loading="submitLoading" @click="submit()">
									ذخیره
								</v-btn>
							</v-card-actions>
						</v-form>
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ModifyLoanPayment from '@/views/admin/ModifyLoanPayment.vue'

	export default {
		name: 'CheckoutThisMonth',
		props: {
			data: {}
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'modify-loan-payment': ModifyLoanPayment,
		},
		data() {
			return {
				dialogModifyCommissionPayment: false,
				selectedAffiliateCommission: null,
				errorMessages: '',
				search: '',
				loading: false,
				submitLoading: false,
				sum: 0,
				sumPayments: 0,
				headers: [
					{
						text: 'تاریخ',
						align: 'center',
						sortable: true,
						value: 'date_Persian',
						excel_value: 'date_Persian.date',
					}, {
						text: 'توضیحات',
						align: 'start',
						sortable: true,
						value: 'description',
					}, {
						text: 'مبلغ کل',
						align: 'center',
						sortable: true,
						value: 'purchase.amount',
					}, {
						text: 'پورسانت',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'میزان تسویه',
						align: 'center',
						sortable: true,
						value: 'paidToUser',
					}, {
						text: 'ثبت پرداختی',
						align: 'center',
						sortable: false,
						width: 110,
					},
				],
				items: [],
			}
		},
		computed: {
			excelFileName() {
				let name = 'لیست پورسانت ها'
				// if (this.startDate)
				// 	name += ' از ' + this.startDate.toString().split('T')[0]
				// if (this.endDate)
				// 	name += ' تا ' + this.endDate.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			edit(commission) {
				this.selectedAffiliateCommission = { id: commission.id, paidToUser: commission.paidToUser, amount: commission.amount }
				this.dialogModifyCommissionPayment = true
			},
			loadData() {
				this.loading = true
				api.get('superadmin/AffiliateCommission/list/' + this.data.id, {})
					.then(
						response => {
							this.items = response
							this.sum = response.reduce(function (a, b) {
								return a + b.amount
							}, 0)
							this.sumPayments = response.reduce(function (a, b) {
								return a + b.paidToUser
							}, 0)
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			submit() {
				if (!this.$refs.form.validate())
					return
				this.submitLoading = true
				api.post('superadmin/AffiliateCommission/commissionPayment', { id: this.selectedAffiliateCommission.id, paidToUser: this.selectedAffiliateCommission.paidToUser })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.dialogModifyCommissionPayment = false
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			}
		},
	}
</script>
<style>
</style>
